import { render, staticRenderFns } from "./DpvDescriptionModal.vue?vue&type=template&id=9ca6c194&scoped=true"
import script from "./DpvDescriptionModal.vue?vue&type=script&lang=js"
export * from "./DpvDescriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca6c194",
  null
  
)

export default component.exports